module.exports = {"last_5min":"過去五分鐘","last_hour":"過去一小時","last_three_hour":"過去三小時","last_six_hour":"過去六小時","last_day":"過去一天","last_seven_day":"過去七天","last_month":"上個月","this_month":"本月至今","custom":"自定義","search":"搜索","selectServerNameText":"域名","selectAppProfileNameText":"專案","selectOriginText":"源站","selectServiceGroupText":"站點","selectAppProfileText":"服務","selectedGroupNameText":"群组","selectedSlbNameText":"SLB","selectedEdgeNameText":"EDGE"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/home.json
// module id = 0n5M
// module chunks = 3